import React, { useEffect, useState } from "react";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";

import CartList from "./CartList/Component";
import PaymentBottomBar from "./BottomPayment/component";
import AutoApplyPopup from "./Popup/AutoApplyPopup";
import CouponsList from "./CouponList/Component";
import CouponDialog from "./Popup/CouponPopup";
import WaitingLoder from "../../Loader/component";
import { useWebSocket } from "../../Websocket/useWebSocket";
import PaymentStatus from "./PaymentStatus/Component";
import EmptyCartDialog from "./Popup/EmptyCartDialog";
import LowBalanceModal from "./Popup/2";
import AddGoogleNumber from "../Userprofile/AddGoogleNumber";
import GoogleSuccessModal from "../Userprofile/GoogleSuccessModal";
import GoogleNumberOtpModal from "../Userprofile/GoogleNumberOtpModal";
import ConfirmCoupon from "./RemoveCouponPopup";
import { setWebSocketData } from "../../Websocket/webSocketAction";
import Delete from "../../assets/delete.png";
import NoInternet from "../../NoInterNet/component";
import { WEB_SOCKET_BASE_URL ,API_BASE_URL} from "../../config";

// ─────────────────────────────────────────────────────────────
;

// ─────────────────────────────────────────────────────────────
const MyHeader = ({ handleBack, handleEmpty }) => (
  <Box
    display="flex"
    alignItems="center"
    p={2}
    sx={{ background: "#fae14b", position: "fixed", width: "100%", zIndex: 999 }}
  >
    <Box display="flex" width="100%" alignItems="center" justifyContent="space-between">
      <Box display="flex">
        <IconButton onClick={handleBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
          My Cart
        </Typography>
      </Box>
      <img src={Delete} onClick={handleEmpty} style={{ width: "30px" }} />
    </Box>
  </Box>
);

// ─────────────────────────────────────────────────────────────
const MyCartContainer = () => {
  const { makeApiRequest } = useApiRequest();
  const dispatch = useDispatch();
  const { wsData, startWebSocket } = useWebSocket();
  const navigate = useNavigate();
  const location = useLocation();

  // ── URL params ──────────────────────────────────────────────
  const searchParams = new URLSearchParams(location.search);
  const machineIdParams = searchParams.get("machineId");

  // ── Cart ────────────────────────────────────────────────────
  const [cartList, setCartList] = useState([]);
  const [machineId, setMachineId] = useState(null);
  const [fullObjectRewardCart, setFullObjectRewardCart] = useState(null);
  const [isSample, setIsample] = useState(false);
  const [orderAmount, setOrderAmount] = useState(null);

  // ── Payment ─────────────────────────────────────────────────
  const [paymentOptionData, setPaymentOption] = useState([]);
  const [paymentStatusFlag, setPaymentStatusFlag] = useState(false);
  const [orderSucessStatus, setOrderSucessStatus] = useState(false);
  const [orderSucessOrderId, setOrderSucessOrderId] = useState(null);
  const [orderSucessPaymentMethod, setOrderSucessPaymentMethod] = useState(null);
  const [flagLowBalance, setFlagLowBalance] = useState(false);

  // ── Coupons ─────────────────────────────────────────────────
  const [couponsList, setCouponsList] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [couponAppliedSuccess, setCouponAppliedSuccess] = useState(false);
  const [removebtnflag, setRemovebtnflag] = useState(true);
  const [cartReward, setCartReward] = useState(null);

  // ── Popup visibility flags ───────────────────────────────────
  const [showCoupoListFlag, setShowCoupoListFlag] = useState(false);   // CouponsList screen
  const [showCouponPopFlag, setShowCouponPopFlag] = useState(false);   // CouponDialog popup
  const [showSuccessAfterConsent, setShowSuccessAfterConsent] = useState(false); // CouponDialog after ConfirmCoupon "Yes"
  const [isAutoCoupon, setIsAutoCoupon] = useState(false);             // was coupon auto-applied?
  const [confirmRemoveCouponflag, setConfirmRemoveCouponflag] = useState(false);
  const [openEmptyCart, setOpenEmptyCart] = useState(false);
  //const [consent, setConsent] = useState(false);
  const [consent, setConsentState] = useState(
  () => localStorage.getItem("coupon_consent") === "true"
);

const setConsent = (val) => {
  setConsentState(val);
  if (val) localStorage.setItem("coupon_consent", "true");
  else localStorage.removeItem("coupon_consent");
};

  // ── Google auth ─────────────────────────────────────────────
  const [google_Pop_flag, setGoogle_Pop_flag] = useState(false);
  const [google_OTP_Pop_flag, setGoogle_OTP_Pop_flag] = useState(false);
  const [google_success_flag, setGoogle_success_flag] = useState(false);
  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [google_requestId, setGoogle_requestId] = useState(null);
  const [numberError, setNumberError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [numberErrorMsg, setNumberErrorMsg] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");

    // ✅ Offline state — drives the NoInternet screen
  const [noInternet, setNoInternet] = useState(false);
    const Guest_OauthToken =localStorage.getItem("Guest_OauthToken")
  // ── Misc ────────────────────────────────────────────────────
  const [loader, setLoader] = useState(false);

  // ─────────────────────────────────────────────────────────────
  // Popup logic:
  //
  //  Auto coupon + isSample=true  →  ConfirmCoupon → (Yes) → CouponDialog (success)
  //  Auto coupon + isSample=false →  CouponDialog (success/fail)
  //  CouponsList apply (any item) →  CouponDialog (success/fail)   [isAutoCoupon=false]
  //  Manual remove coupon         →  ConfirmCoupon  (confirmRemoveCouponflag)
  // ─────────────────────────────────────────────────────────────

  // Called when user taps "Yes, Continue" in ConfirmCoupon
  const handleConsentConfirm = () => {
    setShowCouponPopFlag(false);
    setShowSuccessAfterConsent(true);
  };

  // ── Init ─────────────────────────────────────────────────────
  useEffect(() => {
    if(!Guest_OauthToken){
    
  
   
    }
      fetchUserDetails();
    fetchPreCard();
     //fetchAutoCoupon();
    
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("SodexoPaymentRequestId")) {
      setLoader(true);
      const id = new URLSearchParams(window.location.search).get("q");
      fetchSodexoPaymentStatus(id);
    }
  }, []);


  const handleNetworkError = (error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  };

  // ── WebSocket ────────────────────────────────────────────────
  const handleStartWebSocket = (orderId) => {
    const url = `${WEB_SOCKET_BASE_URL}/consumerbe/status/payment?order_id=${orderId}`;
    startWebSocket(url, (data) => {
      dispatch(setWebSocketData(data));
      setPaymentStatusFlag(true);
      setOrderSucessStatus(data?.success);
      setOrderSucessOrderId(data?.orderId);
      setOrderSucessPaymentMethod(data?.pgName);
      setLoader(false);
    });
  };

  // ── Sodexo ───────────────────────────────────────────────────
  const fetchSodexoPaymentStatus = (paymentId) => {
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");
    if (!token) return;

    makeApiRequest({
      url: `${API_BASE_URL}/payment/api/v2/sodexo/payment/status/${paymentId}`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: (res) => {
        localStorage.removeItem("SodexoPaymentRequestId");
        if (res?.data?.data?.success === false) {
          navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`);
        } else {
          navigate(`/pickupOptions/${localStorage.getItem("orderId")}`);
        }
      },
      handleError: () => navigate(`/pickupOptions/${localStorage.getItem("orderId")}`),
    });
  };

  // ── Cart APIs ────────────────────────────────────────────────
  const fetchPreCard = async (e) => {
    setLoader(true);
    e?.stopPropagation?.();
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (!token) {
      toast.error("Please login to continue");
      return   navigate("/login", {state: { from: location.pathname + location.search }, });
    }

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: handleResponsePreCard,
      handleError: handleErrorPreCard,
    });
  };

  const handleResponsePreCard = (response) => {
  setLoader(false);
  try {
    const data = response?.data?.data || {};
    const items = data?.items || [];

    setIsample(data.isSample);

    if (!items.length) {
      navigate(`/items?machineId=${localStorage.getItem("machineId")}&value=null&showItems=true`);
      return;
    }

    setFullObjectRewardCart(response.data);
    setCartList(items);
    setCartReward(data.reward);
    setIsample(data.isSample);

    const CartMachineId = response?.headers?.machineid;
    setMachineId(CartMachineId);
    localStorage.setItem("card_id", response?.headers["cart-id"]);

    PaymentOptionApi(machineIdParams || CartMachineId);

    // ✅ Only auto-apply if no reward already on the cart
    if (!data.reward) {
      fetchAutoCoupon();
    }
  } catch (error) {
    console.error("Error handling PreCard response:", error);
  }
};
/*   const handleResponsePreCard = (response) => {
    setLoader(false);
    try {
      const data = response?.data?.data || {};
      const items = data?.items || [];

      setIsample(data.isSample);

      if (!items.length) {
        navigate(`/items?machineId=${localStorage.getItem("machineId")}&value=null&showItems=true`);
        return;
      }

      setFullObjectRewardCart(response.data);
      setCartList(items);
      setCartReward(data.reward);

      const CartMachineId = response?.headers?.machineid;
      setMachineId(CartMachineId);
      localStorage.setItem("card_id", response?.headers["cart-id"]);

      PaymentOptionApi(machineIdParams || CartMachineId);
    } catch (error) {
      console.error("Error handling PreCard response:", error);
    }
  }; */

  const handleErrorPreCard = (error) => {
     if (handleNetworkError(error)) return;
    setLoader(false);
    toast.error("Failed to load cart data. Please try again.");
  };

  const handleCartOpertation = (e, index, slot_id, currentCount, operation) => {
    e.stopPropagation();
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return    navigate("/login", {state: { from: location.pathname + location.search },      });

    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machineId}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slot_id), count: payloadCount }],
      handleSuccess: () => {
        fetchPreCard();
        fetchAutoCoupon();
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        toast.error(`${error.response?.data?.status?.message}`, {
          position: "top-right",
          autoClose: 1500,
        });
      },
    });
  };

  const clearPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");
    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: () => {

         
        navigate(`/items?machineId=${localStorage.getItem("machineId")}&value=null&showItems=true`);
        setOpenEmptyCart(false);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setOpenEmptyCart(false)

      }
    });
  };

  // ── Coupon APIs ──────────────────────────────────────────────
  const fetchAutoCoupon = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    if (!UserJWTAuth) return navigate("/login", {state: { from: location.pathname + location.search },      });


    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/coupon/auto-applicable?pgId=${localStorage.getItem("defaultPgId")}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "WEB",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
        console.log("cartReward",cartReward)
          if (cartReward) return; 

        if (res.data.data?.[0]) ApplyCoupon(res.data.data[0].couponName, true);
      },
      handleError: (error) => {
         if (handleNetworkError(error)) return;
      },
    });
  };

  const fetchCouponsList = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    setShowCoupoListFlag(true);
    if (!UserJWTAuth) return navigate("/login");

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/coupon`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
      
        setCouponsList(res.data.data)
      
      },
      handleError: (error) => { 
        setShowCoupoListFlag(false)

        if (handleNetworkError(error)) return;


      },
    });
  };

const fetchCartOnly = () => {
  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
  if (!token) return  navigate("/login", {state: { from: location.pathname + location.search },      });


  makeApiRequest({
    url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    handleSuccess: (response) => {
      const data = response?.data?.data || {};
      const items = data?.items || [];
      setFullObjectRewardCart(response.data);
      setCartList(items);
      setCartReward(data.reward);
      setIsample(data.isSample);
    },
    handleError: (error) => {
       if (handleNetworkError(error)) return;
      toast.error("Failed to refresh cart. Please try again.");
    },
  });
};

  const ApplyCoupon = (couponName, auto) => {
    
    setCouponCode(couponName);
    const token = localStorage.getItem("UserJWTAuth");
  
    const deviceId = localStorage.getItem("uuid");
    const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);
    if (!token) return navigate("/login", {state: { from: location.pathname + location.search },      });


    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart/coupon`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      data: { couponName, pgName: defaultPgId },
      handleSuccess: (res) => {
        setIsAutoCoupon(!!auto);
        if (auto) setRemovebtnflag(false);
        setCouponAppliedSuccess(true);
        setShowCouponPopFlag(true);
        setShowCoupoListFlag(false);
        fetchCartOnly()
      },
      handleError: (error) => {
         
        setIsAutoCoupon(false);
        setCouponAppliedSuccess(false);
        setShowCouponPopFlag(true);
        if (handleNetworkError(error)) return;
      },
    });
  };

  const RemoveCoupon = () => {
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");
    if (!token) return  navigate("/login", {state: { from: location.pathname + location.search },      });


    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart/coupon`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      data: {},
      handleSuccess: () => {
        fetchPreCard();
        setConfirmRemoveCouponflag(false);
        setShowCouponPopFlag(false);
        setShowSuccessAfterConsent(false);
        setCouponAppliedSuccess(false);
        setConsent(false);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        toast.error("Failed to remove coupon. Please try again.");
        setConfirmRemoveCouponflag(false);
        setShowCouponPopFlag(false);
        setShowSuccessAfterConsent(false);
        setCouponAppliedSuccess(false);
        setConsent(false);

      },
    });
  };

  const handleCloseCouponPopup = () => {
    setShowCouponPopFlag(false);
    setShowSuccessAfterConsent(false);
    fetchPreCard();
  };

  // ── Payment APIs ─────────────────────────────────────────────
  const PaymentOptionApi = (CartMachineId) => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    if (!UserJWTAuth) return navigate("/login", {state: { from: location.pathname + location.search },      });


    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/payment/option?machineId=${CartMachineId}&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => setPaymentOption(res.data.data),
      handleError: (error) => {
        if (handleNetworkError(error)) return;},
    });
  };

  const getPgById = (id) => paymentOptionData.find((item) => item.pgId === id);

  const CreateOrderApi = () => {
    setLoader(true);
    const totalAmount = cartList.reduce((sum, item) => sum + item.count * item.amount, 0);
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const uuid = localStorage.getItem("uuid");
    const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);
    const pgdata = getPgById(defaultPgId);

  const rewardData = fullObjectRewardCart?.data?.reward;
  const comboCart = fullObjectRewardCart?.data?.comboCart;

  /** ------------------------------
   *  TOTALS CALCULATION
   * ------------------------------ */
  const totalAmount_ = fullObjectRewardCart?.data?.items?.reduce(
    (sum, item) => sum + item.amount * item.count,
    0
  ) || 0;

  const discountedTotal = fullObjectRewardCart?.data?.items?.reduce(
    (sum, item) => sum + (item.discountedAmount ?? 0),
    0
  ) || 0;

  const discountValue = rewardData?.count || 0;
  const discountApplied = rewardData?.discountApplied;
console.log("discount value---",discountValue)
  const finalAmountAfterDiscount = discountApplied
    ? totalAmount_ - discountValue
    : totalAmount_;

  let finalAmount = discountedTotal || totalAmount_;
  if (!finalAmount && comboCart) {
    finalAmount = comboCart.totalPrice;
  }
    if (pgdata && (pgdata.pgId === 8 || pgdata.pgId === 9)) {
      if (pgdata.balance !== null && pgdata.balance < finalAmount) {
        setFlagLowBalance(true);
        setLoader(false);
        return;
      }
    }

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/${machineId}/order`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": uuid,
      },
      data: { type: "regular" },
      handleSuccess: (res) => {
        const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);
        const pgdata = getPgById(defaultPgId);

        if (pgdata && (pgdata.pgId === 8 || pgdata.pgId === 9)) {
          if (pgdata.balance !== null && pgdata.balance < res.data.data.amount) {
            setFlagLowBalance(true);
            setLoader(false);
            return;
          }
        }

        setOrderAmount(res.data.data.amount);
        InitiatedPaymentApi(res.data.data.orderId, res.data.data.amount);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        toast.error(`${error.response?.data?.status?.message}`, {
          position: "top-right",
          autoClose: 1500,
        });
        setLoader(false);
      },
    });
  };

  const InitiatedPaymentApi = (orderId, amount) => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);
    const uuid = localStorage.getItem("uuid");

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/order/${orderId}/payment`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": uuid,
      },
      data: { pgId: defaultPgId },
      handleSuccess: (res) => handleResponseInitiatedPayment(res, orderId, amount),
      handleError: (error) => {
if (handleNetworkError(error)) return;

      },
    });
  };

  const handleResponseInitiatedPayment = (res, orderId, amount) => {
    const defaultPgName = localStorage.getItem("defaultPgName");

    if (["R_CARD", "R_WALLET", "R_UPI"].includes(defaultPgName)) {
      razorpay(orderId, amount);
    }

    if (defaultPgName === "SODEXO") {
      localStorage.setItem("orderId", orderId);
      localStorage.setItem("SodexoPaymentRequestId", res.data.data.sodexoRedirectOptions.requestId);
      window.location.replace(res.data.data.sodexoRedirectOptions.redirectUrl);
    }

    handleStartWebSocket(orderId);
  };

  const razorpay = (orderId, amount) => {
    const defaultPgName = localStorage.getItem("defaultPgName");
    const razorpayMethod =
      defaultPgName === "R_CARD" ? "card" : defaultPgName === "R_WALLET" ? "wallet" : "upi";
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const mobileNo = JSON.parse(localStorage.getItem("mobileNo")) || "";

    const options = {
      key: "rzp_live_ZVpG4pXQKTLFCS",
      amount: (amount * 100).toString(),
      currency: "INR",
      name: "Daalchini",
      description: `Order ID: ${orderId}`,
      prefill: { email: "info@daalchini.co.in", contact: mobileNo, method: razorpayMethod },
      theme: { color: "#432B2B", hide_topbar: false },
      notes: { order_id: orderId },
      handler: (response) => handlePaymentSuccess(response, orderId),
      onpaymenterror: (error) => navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`),
      modal: {
        ondismiss: () => {
          navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`);
          document.getElementById("razorpay-container")?.remove();
        },
      },
    };

    const rzp = new window.Razorpay(options);
    setLoader(false);
    rzp.open();
  };

  const handlePaymentSuccess = (response, orderId) => handleStartWebSocket(orderId);

  // ── Google auth ──────────────────────────────────────────────
  const fetchUserDetails = () => {
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");
    if (!token) return;

    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/profile/details`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: { request: { oauthToken: `Bearer ${token}` } },
      handleSuccess: (res) => {
        if (res?.data?.response?.referCode) {
          localStorage.setItem("referCode", res.data.response.referCode);
        }
        setLoader(false);
      },
      handleError: (error) => {
      
        setLoader(false);
        const status = error?.response?.status;
        if ((status === 401 || status === 403) && localStorage.getItem("google_jwt")) {
          setGoogle_Pop_flag(true);
        } else {
         /*  toast.error(error?.response?.data?.status || "Something went wrong", {
            position: "top-right",
            autoClose: 1000,
          }); */
        }
          if (handleNetworkError(error)) return;
      },
    });
  };

  const googleAddnumber = () => {
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (number.length !== 10) {
      setNumberError(true);
      setNumberErrorMsg("Enter a valid mobile number");
      return;
    }

    setNumberError(false);
    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/authenticate`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: { request: { mobileNo: number, googleId: localStorage.getItem("gmail") } },
      handleSuccess: (res) => {
        setGoogle_requestId(res.data.response.requestId);
        setGoogle_Pop_flag(false);
        setGoogle_OTP_Pop_flag(true);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setNumberError(true);
        setNumberErrorMsg(error.response.data.statusMessage);
        toast.error(error.response.data.statusMessage, { position: "top-right", autoClose: 1000 });
      },
    });
  };

  const googleOtpSubmit = () => {
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (otp.length !== 4) { setOtpError(true); return; }
    setOtpError(false);

    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/login`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: { deviceId, fcmUserToken: null, mobileNo: number, otp, requestId: google_requestId, sourcePlatform: "web" },
      },
      handleSuccess: (res) => {
        const response = res?.data?.response;
        if (response) {
          setGoogle_success_flag(true);
          setGoogle_OTP_Pop_flag(false);
          localStorage.setItem("UserJWTAuth", response.jwt);
          localStorage.setItem("referCode", response.referCode);
          localStorage.setItem("isUserLogged", response.isUserLogged);
          localStorage.setItem("isGuest", response.isGuest);
          localStorage.setItem("isTokenExpired", response.isTokenExpired);
        } else if (res?.data?.status === "FAILURE") {
          setOtpError(true);
          setOtpErrorMsg(res?.data?.statusMessage);
          toast.error(res?.data?.statusMessage, { position: "top-right", autoClose: 1000 });
        }
      },
      handleError: (error) =>{ 
        if (handleNetworkError(error)) return;
        setOtpError(true)

      }
    });
  };

  // ── Helpers ──────────────────────────────────────────────────
 const handleBack = () => {
  const from = location.state?.from;
  if (from) {
    navigate(from);
  } else {
    navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`);
  }
};
  const handleEmpty = () => setOpenEmptyCart(true);

  const CouponText = () =>
    couponAppliedSuccess ? (
      <>Your coupon code <strong>{couponCode}</strong> applied successfully!</>
    ) : (
      <>Coupon code <strong>{couponCode}</strong> does not exist for this item. Please try again!</>
    );

  // ─────────────────────────────────────────────────────────────
  // Render CouponsList as a full screen swap
  // ─────────────────────────────────────────────────────────────
  if (showCoupoListFlag) {
    return (
      <CouponsList
        setShowCoupoListFlag={setShowCoupoListFlag}
        couponsList={couponsList}
        ApplyCoupon={ApplyCoupon}
        CouponText={CouponText}
        showCouponPopFlag={showCouponPopFlag}
        handleCloseCouponPopup={handleCloseCouponPopup}
        couponAppliedSuccess={couponAppliedSuccess}
      />
    );
  }

  if (noInternet) return <NoInternet />;

  // ─────────────────────────────────────────────────────────────
  // Main render
  // ─────────────────────────────────────────────────────────────
  return (
    <>
      {/* ── Google auth popups ─────────────────────────────── */}
      {google_success_flag && <GoogleSuccessModal />}
      {google_OTP_Pop_flag && (
        <GoogleNumberOtpModal
          setOtp={setOtp}
          otp={otp}
          googleOtpSubmit={googleOtpSubmit}
          closeOTpPop={() => { setGoogle_Pop_flag(true); setGoogle_OTP_Pop_flag(false); }}
          google_OTP_Pop_flag={google_OTP_Pop_flag}
          otpErrorMsg={otpErrorMsg}
          otpError={otpError}
          googleAddnumber={googleAddnumber}
        />
      )}
      {google_Pop_flag && !localStorage.getItem("isGuest") && (
        <AddGoogleNumber
          google_Pop_flag={google_Pop_flag}
          googleAddnumber={googleAddnumber}
          closePop={() => { setGoogle_Pop_flag(false); navigate("/"); }}
          setNumber={setNumber}
          number={number}
          numberError={numberError}
          numberErrorMsg={numberErrorMsg}
        />
      )}

      {/* ── Low balance ────────────────────────────────────── */}
      <LowBalanceModal open={flagLowBalance} onClose={() => setFlagLowBalance(false)} />

      {/* ── Coupon popups ──────────────────────────────────── */}
      {/*
        Step 1: Auto-applied on a sample item → show consent popup
        Step 2: User taps "Yes" → show success CouponDialog
        Other:  Any other case (manual, non-sample) → show CouponDialog directly
      */}
      {showCouponPopFlag && isSample && isAutoCoupon && !consent&& (
        <ConfirmCoupon
          couponCode={couponCode}
          RemoveCoupon={RemoveCoupon}
          setConfirmRemoveCouponflag={setConfirmRemoveCouponflag}
          fullObjectRewardCart={fullObjectRewardCart}
          setConsent={setConsent}
          onConfirm={handleConsentConfirm}
        />
      )}

      {showSuccessAfterConsent && (
        <CouponDialog
          CouponText={CouponText}
          handleCloseCouponPopup={handleCloseCouponPopup}
          couponAppliedSuccess={true}
        />
      )}

      {showCouponPopFlag && !(isSample && isAutoCoupon) && (
        <CouponDialog
          CouponText={CouponText}
          handleCloseCouponPopup={handleCloseCouponPopup}
          couponAppliedSuccess={couponAppliedSuccess}
        />
      )}

      {/* ── Manual remove coupon confirm ───────────────────── */}
      {confirmRemoveCouponflag && (
        <ConfirmCoupon
          couponCode={couponCode}
          RemoveCoupon={RemoveCoupon}
          setConfirmRemoveCouponflag={setConfirmRemoveCouponflag}
          fullObjectRewardCart={fullObjectRewardCart}
          setConsent={setConsent}
        />
      )}

      {/* ── Payment status screen ──────────────────────────── */}
      {paymentStatusFlag ? (
        <PaymentStatus
          onTimerComplete={() => navigate(`/pickupOptions/${orderSucessOrderId}`)}
          status={orderSucessStatus}
          amount={"100"}
          orderId={orderSucessOrderId}
          paymentMethod={orderSucessPaymentMethod}
        />
      ) : (
        <>
          {loader && <WaitingLoder />}
          {openEmptyCart && (
            <EmptyCartDialog
              setOpenEmptyCart={setOpenEmptyCart}
              openEmptyCart={openEmptyCart}
              clearPreCart={clearPreCart}
            />
          )}

          <MyHeader handleBack={handleBack} handleEmpty={handleEmpty} />
          <CartList
            cartList={cartList}
            increaseQuantity={handleCartOpertation}
            decreaseQuantity={handleCartOpertation}
            fetchCouponsList={fetchCouponsList}
            ConformRemoveCoupon={RemoveCoupon}
            setShowCoupoListFlag={setShowCoupoListFlag}
            fullObjectRewardCart={fullObjectRewardCart}
            removebtnflag={removebtnflag}
            RemoveCoupon={RemoveCoupon}
          />
          <PaymentBottomBar
            paymentOptionData={paymentOptionData}
            CreateOrderApi={CreateOrderApi}
            fullObjectRewardCart={fullObjectRewardCart}
          />
        </>
      )}
    </>
  );
};

export default MyCartContainer;
